import PropTypes from "prop-types";
import clsx from "clsx";

// MUI
import { Stack, Typography } from "@mui/material";

// Icons
import { ICONS_GREY, ICONS_WHITE } from "@PayPlans/helpers/defaultIcons";

export default function DefaultInformation(props) {
	const { position = "", label = "", selected = false } = props;

	return (
		<Stack direction="row" alignItems="center">
			<Stack>
				<img
					src={selected ? ICONS_WHITE.get(position) : ICONS_GREY.get(position)}
					alt="car"
					style={{
						height: "15px",
						marginRight: "5px",
					}}
				/>
			</Stack>
			<Stack>
				<Typography
					className={clsx({ "!font-montserrat !font-[600]": true, "text-white": selected, "text-default": !selected })}
					fontSize={"10px"}
				>
					{label}
				</Typography>
			</Stack>
		</Stack>
	);
}
DefaultInformation.propTypes = {
	position: PropTypes.string,
	selected: PropTypes.bool,
	label: PropTypes.string,
};
